var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCameraDomeIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.13861 10.7715L2.30059 6.25H22.3301L21.6102 10.7715H3.13861Z",
  fill: "#C7CED4",
  stroke: "#797979",
  strokeWidth: 0.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.3959 11.9437C20.1289 13.898 19.1629 15.6893 17.6768 16.9862C16.1907 18.2831 14.2851 18.9977 12.3127 18.9977C10.3403 18.9977 8.43465 18.2831 6.94854 16.9862C5.46244 15.6893 4.49649 13.898 4.22949 11.9437H20.3959Z",
  fill: "#42A5F5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.2438 11.0214C21.2432 11.2661 21.1456 11.5007 20.9723 11.6736C20.799 11.8465 20.5642 11.9436 20.3195 11.9436H4.4365C4.19192 11.9436 3.95735 11.8464 3.7844 11.6735C3.61144 11.5005 3.51428 11.266 3.51428 11.0214H21.2438Z",
  fill: "#3482C1"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  d: "M6.5 10.5H4.5L3.5 6.5H6L6.5 10.5Z",
  fill: "white"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.39,
  d: "M12.5189 17.6547C12.3539 17.9656 11.0129 17.8979 10.721 17.8387C9.80435 17.6689 8.92851 17.3258 8.14049 16.8276C7.34418 16.3237 6.65667 15.6657 6.11837 14.8922C5.82647 14.484 5.33786 13.3926 5.51342 12.8363C5.67629 12.3942 6.50121 12.4619 6.94117 12.4746C7.7386 12.4978 8.34566 12.7369 8.32028 13.7733C8.28432 15.2962 9.10501 16.136 11.2689 16.7684C11.5988 16.8678 12.7516 17.2189 12.5189 17.6547Z",
  fill: "white"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5821 14.8579C15.5821 15.442 15.4088 16.013 15.0842 16.4987C14.7596 16.9843 14.2983 17.3627 13.7585 17.5861C13.2188 17.8095 12.6249 17.8677 12.0521 17.7535C11.4792 17.6392 10.9531 17.3577 10.5403 16.9443C10.1275 16.531 9.84664 16.0046 9.73315 15.4316C9.61965 14.8586 9.67867 14.2648 9.90274 13.7253C10.1268 13.1859 10.5058 12.725 10.9919 12.401C11.478 12.077 12.0492 11.9045 12.6333 11.9053C13.0209 11.9053 13.4046 11.9817 13.7627 12.1301C14.1207 12.2785 14.4459 12.4961 14.7198 12.7703C14.9936 13.0445 15.2108 13.3701 15.3587 13.7283C15.5067 14.0865 15.5826 14.4703 15.5821 14.8579Z",
  fill: "#205C8C"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.48,
  d: "M13.2199 14.264C13.2205 14.4972 13.1521 14.7253 13.0233 14.9197C12.8945 15.114 12.711 15.2659 12.496 15.3562C12.281 15.4465 12.0441 15.4711 11.8152 15.4269C11.5862 15.3827 11.3755 15.2718 11.2095 15.1081C11.0435 14.9443 10.9296 14.7351 10.8823 14.5068C10.835 14.2785 10.8564 14.0413 10.9437 13.825C11.031 13.6088 11.1803 13.4233 11.3729 13.2918C11.5655 13.1603 11.7926 13.0888 12.0258 13.0862C12.1816 13.0849 12.3361 13.1144 12.4805 13.1729C12.6249 13.2315 12.7563 13.3179 12.8672 13.4273C12.9782 13.5367 13.0664 13.667 13.1269 13.8105C13.1874 13.9541 13.219 14.1082 13.2199 14.264Z",
  fill: "#4287BF"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  },
  opacity: 0.43
}, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M22.6231 6.00842L21.8236 11.0299H21.244C21.2434 11.2747 21.1458 11.5092 20.9725 11.6821C20.7992 11.855 20.5645 11.9521 20.3197 11.9521H20.3958C20.1266 13.9051 19.1597 15.6946 17.6737 16.9901C16.1876 18.2856 14.283 18.9995 12.3116 18.9999C11.9393 18.9996 11.5676 18.9735 11.199 18.9216C16.2564 17.9846 17.6778 15.567 18.1791 11.9521H18.1051C18.3497 11.9521 18.5842 11.8549 18.7572 11.682C18.9301 11.509 19.0273 11.2745 19.0273 11.0299H19.6069L19.996 6.00842H22.6231Z",
  fill: "#808080"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCameraDomeIcon);
export default ForwardRef;